'use client'

import { Skeleton } from '@/components/ui/skeleton'

export function ListingCardSkeleton() {
  return (
    <div className="bg-card rounded-xl overflow-hidden border border-border">
      {/* Image skeleton */}
      <Skeleton className="aspect-[4/3] w-full" />

      {/* Content skeleton */}
      <div className="p-3 space-y-1.5">
        {/* Title */}
        <Skeleton className="h-4 w-4/5" />
        <Skeleton className="h-3 w-3/5" />

        {/* Rooms/area */}
        <Skeleton className="h-3 w-1/2" />

        {/* Location + price row */}
        <div className="flex items-center justify-between pt-0.5">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-6 w-28" />
        </div>

        {/* Buttons */}
        <div className="flex gap-1.5 pt-1">
          <Skeleton className="h-7 w-24 rounded-lg" />
          <Skeleton className="h-7 flex-1 rounded-lg" />
        </div>
      </div>
    </div>
  )
}

